import "./App.css";
import React from "react";
import { useState, useEffect } from "react";
import Header from "./components/Header";
import Schedule from "./components/Schedule";
import { Route, Routes } from "react-router";
import Acquisition from "./components/Acquisition";
import Footer from "./components/Footer";
import Collective from "./components/Collective";
import { fetchCollectives } from "./api/strapi";
import { useTranslation } from "react-i18next";

function App() {
  const [collectives, setCollectives] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    fetchCollectives(i18n.language)
      .then((data) => {
        console.log(data);
        setCollectives(data);
      })
      .catch((_) => {
        setCollectives([]);
      });
  }, []);

  return (
    <div className="flex flex-col">
      <Header></Header>
      <div className="lg:w-5/6 w-11/12 mx-auto flex-auto min-h-screen">
        <Routes>
          <Route path="/" element={<Schedule />}></Route>
          <Route
            path="/buy-de-broek-fundraiser"
            element={<Acquisition />}
          ></Route>
          {collectives.map((c, i) => {
            return (
              <Route
                path={c.linkname}
                element={<Collective collective={c} />}
              ></Route>
            );
          })}
        </Routes>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default App;
